import { Flex } from '@mantine/core';
import { LineChartLegendItemWithCheckbox } from '../../../components/line-chart/line-chart-legend-item-with-checkbox';

type LegendPhaseItem = {
  id: string;
  label: string;
  color: string;
  description: string;
};

interface WorkPhaseDistributionChartLegendProps {
  phases: LegendPhaseItem[];
  visiblePhases: Record<string, boolean>;
  onPhaseToggle: (phaseId: string) => void;
}

export const WorkPhaseDistributionChartLegend = ({
  phases,
  visiblePhases,
  onPhaseToggle,
}: WorkPhaseDistributionChartLegendProps) => {
  return (
    <Flex justify="center" align="center" gap="md" h="100%" wrap="wrap">
      {phases.map((phase) => {
        return (
          <LineChartLegendItemWithCheckbox
            key={`legend-item-${phase.id}`}
            value={phase.id}
            label={phase.label}
            color={phase.color}
            isChecked={visiblePhases[phase.id]}
            onToggle={() => onPhaseToggle(phase.id)}
          />
        );
      })}
    </Flex>
  );
};
